export const clr = {
  light: {
    main: '#0095f7',
    logo: '#fff',
    heading: '#1e1e1e',
    text: '#1e1e1e',
    'text-alt': '#fff',
    nav: '#495057',
    link: '#0095f7',
    'link-alt': '#fff',
    muted: '#6c757d',
    front: '#fff',
    back: '#f2f2f2',
    btn: '#0095f7',
    'btn-alt': '#fff',
    error: '#e31616',
    'error-alt': '#fff',
    warning: '#f5a623',
    'warning-alt': '#fff',
    success: '#43bf48',
    'success-alt': '#fff',
    ghost: '#1e1e1e20',
    hover: '#1e1e1e08',
    row: '#1e1e1e08',
    progress: '#1e1e1e17',
    border: '#1e1e1e18',
    'input-border': '#d1d1d1',
    thumb: '#c5c5c5',
    'thumb-hover': '#a5a5a5',
    track: '#00000005',
    mark: '#0095f725',
    loader: '#b1b1b1'
  },
  dark: {
    main: '#0095f7',
    logo: '#fff',
    heading: '#fff',
    text: '#eee',
    'text-alt': '#fff',
    nav: '#bababa',
    link: '#0095f7',
    'link-alt': '#fff',
    muted: '#b1b1b1',
    front: '#282E39',
    back: '#222630',
    btn: '#0095f7',
    'btn-alt': '#fff',
    error: '#EA2E2E',
    'error-alt': '#fff',
    warning: '#f5a623',
    'warning-alt': '#fff',
    success: '#43bf48',
    'success-alt': '#fff',
    ghost: '#B7C0CC20',
    hover: '#B7C0CC09',
    row: '#B7C0CC07',
    progress: '#B7C0CC15',
    border: '#B7C0CC15',
    'input-border': '#626970',
    thumb: '#959595',
    'thumb-hover': '#b5b5b5',
    track: '#ffffff05',
    mark: '#0095f735',
    loader: '#6c757d'
  }
}

export const colors = {
  brand: {
    main: 'var(--main)',
    heading: 'var(--heading)',
    text: 'var(--text)',
    'text-alt': 'var(--text-alt)',
    muted: 'var(--muted)',
    nav: 'var(--nav)',
    link: 'var(--link)',
    'link-alt': 'var(--link-alt)',
    logo: 'var(--logo)',
    front: 'var(--front)',
    back: 'var(--back)',
    border: 'var(--border)',
    'input-border': 'var(--input-border)',
    btn: 'var(--btn)',
    'btn-alt': 'var(--btn-alt)',
    error: 'var(--error)',
    'error-alt': 'var(--error-alt)',
    success: 'var(--success)',
    'success-alt': 'var(--success-alt)',
    warning: 'var(--warning)',
    'warning-alt': 'var(--warning-alt)',
    ghost: 'var(--ghost)',
    hover: 'var(--hover)',
    row: 'var(--row)',
    progress: 'var(--progress)',
    thumb: 'var(--thumb)',
    track: 'var(--track)',
    mark: 'var(--mark)'
  }
}
